<script>
export default {
  name: 'personelSevkOnayList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    rejectRecord(id) {	
      this.$emit('rejectRecord', id);	
    },	
    approveRecord(id) {	
      this.$emit('approveRecord', id);	
    }
  },
};
</script>

<template>
  <tr>
    <td>{{ item.adSoyad }}
    <td> {{ item.santiye }} </td>
    <td> {{ item.pozisyon }}</td>
    <td> {{ item.sevkTarihi|dateTimeView  }}</td>
    <td>
      <v-btn @click="rejectRecord(item.pfaaliyet)" color="darken-3" small icon fat text>
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </td>
    <td>
      <v-btn @click="approveRecord(item.pfaaliyet)" color="darken-3" small icon fat text>
        <v-icon color="success">
        mdi-check
      </v-icon>
      </v-btn>
    </td>
  </tr>
</template>
